export default {
  red: "#F78888",
  yellow: "#F3D250",
  lightBlue: "#90CCF4",
  blue: "#5DA2D5",
  gray: "#ECECEC",
  darkGray: "#1A1A1A",
  darkYellow: '#e2c44a'
};
